import { mapTargetBySelectors } from '@/features/shared/HOCs/withGTM';
import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';

const headlineClass = '.gtm-headline';

enum Selectors {
  Jumplink = '.gtm-jumplink',
  CTA = '.gtm-hero-cta',
}

export const mapTarget = mapTargetBySelectors([Selectors.Jumplink, Selectors.CTA]);

export const onDatalayer = ({ componentRef, target }: OnDatalayerProps) => {
  if (!target) {
    return undefined;
  }

  const documentHeadline = componentRef?.current?.querySelector(headlineClass)?.textContent || '';
  const isJumplink = target?.classList?.contains(Selectors.Jumplink.replace('.', ''));
  const isCTA = target?.classList?.contains(Selectors.CTA.replace('.', ''));
  const variantName = (target?.closest('[data-datalayer-variant]') as HTMLDivElement)?.dataset
    ?.datalayerVariant;

  if (isJumplink) {
    return {
      event: 'clickJumpLinks',
      eventCategory: 'Hero',
      ...(variantName && { variant_name: variantName }),
    };
  }

  if (isCTA) {
    const href = target?.querySelector('a')?.href || '';

    return {
      event: 'clickCTA',
      eventCategory: 'Hero',
      documentHeadline,
      ...(!!href && { href }),
      ...(variantName && { variant_name: variantName }),
    };
  }

  return undefined;
};
